import Mutations from '../../odata/mutations';

export default { ...new Mutations('sectionLineItemAudit'), ...new Mutations('sectionLineItemAudits') };
